import { handleError } from "../../../../utils/helpers";
import { adminBaseApi } from "../../../api";
import { AdminLoginPayload, AdminLoginResponse, AdminTwoFaPayload, AdminTwoFaResponse, InitiateTwoFaPayload, InitiateTwoFaResponse, VerifyGoogleTwoFaResponse } from "./auth.types";

export const adminAuthApi = adminBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    adminLogin: builder.mutation<AdminLoginResponse, AdminLoginPayload>({
      query: (payload) => {
        return {
          url: "admin/login",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    adminTwoFa: builder.mutation<AdminTwoFaResponse, AdminTwoFaPayload>({
      query: (payload) => {
        return {
          url: "admin/verify-login-2fa-otp",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    verifyGoogleTwoFa: builder.mutation<
      VerifyGoogleTwoFaResponse,
      AdminTwoFaPayload
    >({
      query: (payload) => {
        return {
          url: "admin/verify-google-otp",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    initiateTwoFa: builder.mutation<
      InitiateTwoFaResponse,
      InitiateTwoFaPayload
    >({
      query: (payload) => {
        return {
          url: "admin/two-fa-setup",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const { useAdminLoginMutation, useAdminTwoFaMutation, useVerifyGoogleTwoFaMutation, useInitiateTwoFaMutation } = adminAuthApi;
